import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-qa-upload-report',
  templateUrl: './qa-upload-report.component.html',
  styleUrls: ['./qa-upload-report.component.scss']
})
export class QaUploadReportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
